import Index from "@/Pages/Admin/Users/Index.vue"
import Create from "@/Pages/Admin/Users/Create.vue"
import Show from "@/Pages/Admin/Users/Show.vue"
import Edit from "@/Pages/Admin/Users/Edit.vue"
import Applications from "@/Pages/Admin/Users/Applications.vue"

export default [
    {
        path: '/admin/users',
        component: Index,
        name: 'admin.users.index',
        meta: {
            auth: true
        },
    },
    {
        path: '/admin/users/create',
        component: Create,
        name: 'admin.users.create',
        meta: {
            auth: true
        },
    },
    {
        path: '/admin/users/:userId',
        component: Show,
        name: 'admin.users.show',
        meta: {
            auth: true
        },
    },
    {
        path: '/admin/users/:userId/edit',
        component: Edit,
        name: 'admin.users.edit',
        meta: {
            auth: true
        },
    },
    {
        path: '/admin/users/:userId/applications',
        component: Applications,
        name: 'admin.users.applications',
        meta: {
            auth: true
        },
    },
];
